import { configureStore } from '@reduxjs/toolkit';
import grammarReducer from './grammarSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    grammar: grammarReducer,
    auth: authReducer,
  },
});

export default store;